// R16 — THE THREE WAYS OUT OF A DUPLICATE, WRITTEN DOWN ONCE.
//
// I6 RULE 3 (owner, 2026-07-16): no silent duplicates. A person matching one already in this
// member's circle on name + birth date stops at the server and asks, rather than quietly making a
// second copy of the same human. Her answer travels back as one string.
//
// THE FAILURE THIS EXISTS TO PREVENT, and it is R14-4's shape exactly (a god the server did not
// know, silently swapped): a resolution the server does not recognise is NOT an error. It falls
// into the "she has not answered yet" branch, so the duplicate is found again and the prompt comes
// back — she taps "Keep both", the modal reopens, and nothing red happens anywhere. The two strings
// were hand-typed on the server, again in App.tsx, and a third time in the gate.
//
// Imports nothing, so the server, the bundle and a .mjs gate can all load it.

// SHE KEEPS THE ONE SHE HAS, updated in place. The row keeps its id on purpose, so every reading
// already attached to that person stays attached (the persistence law).
export const RESOLUTION_REPLACE = "replace";

// SHE MEANS TWO PEOPLE. A second row is saved deliberately.
export const RESOLUTION_KEEP_BOTH = "keep-both";

// SHE BACKS OUT. Never sent to the server — the save simply does not happen — but it is part of the
// prompt's contract, because a prompt with no way out is a trap and C2 forbids losing her work.
export const RESOLUTION_CANCEL = "cancel";

// The answers the SERVER acts on. Cancel is not among them by design: it is the absence of a save.
export const DUPLICATE_RESOLUTIONS = [RESOLUTION_REPLACE, RESOLUTION_KEEP_BOTH];

// Every way the prompt can end. The gate holds this against the server's roster in both directions:
// a choice the prompt offers that the server ignores is a button that does nothing, and a branch the
// server keeps that no surface can reach is a dead row (R11).
export const PROMPT_CHOICES = [...DUPLICATE_RESOLUTIONS, RESOLUTION_CANCEL];

// What the server branches on. One definition, so "did she answer?" and "what did she answer?"
// can never drift apart into two different answers to the same question.
export function isDuplicateResolution(value) {
  return DUPLICATE_RESOLUTIONS.includes(String(value || ""));
}
